import React, { lazy, Suspense } from 'react';
import { Modal, Spinner } from 'ui';
import languageMapper from 'utils/languageMapper';
import { routes } from 'constants/config';
import request from 'utils/request_ajax';

const UCP = lazy(() =>
  import(/* webpackChunkName: "UCP" */ '@seismic/universal-content-picker'),
);

const Loader = () => {
  return (
    <div className="SeismicContent--Spinner">
      <Spinner size="larger" />
    </div>
  );
};

const UniversalPickerModal = ({
  requestUpdateAndApplyChanges,
  closeModal,
  setIsLoading,
}) => {
  const documentPicked = ({
    repository,
    name,
    libraryContent: { id, teamsiteId },
    applicationUrls: [{ url }],
  }) => {
    const updateParams = {
      repository,
      name,
      library_content_id: id,
      library_content_teamsite_id: teamsiteId,
      universal_link: url,
    };
    setIsLoading(true);
    closeModal();
    requestUpdateAndApplyChanges(updateParams).then(() => setIsLoading(false));
  };

  const onTokenExpired = new Promise(resolve => {
    request
      .get(routes.SEISMIC.REFRESH_TOKEN)
      .then(({ token }) => {
        localStorage.setItem('seismicAuthToken', token);
        resolve({ isSuccess: true, token });
      })
      .fail(() => {
        resolve({ isSuccess: false });
      });
  });

  return (
    <Modal
      className="SeismicContentModal"
      modalWrapperClassName="SeismicContentModal-background"
      shown
      enableFloatingDismiss
      onDismiss={closeModal}
      canClickAway={false}
    >
      <div className="SeismicContentModal-header">
        <div className="SeismicContentModal-header--title">
          {t('questions.types.content.modal.title')}
        </div>
      </div>
      <div className="SeismicContentModal-body">
        <Suspense fallback={<Loader />}>
          <UCP
            apiOptions={{
              authTokenResolver: () => localStorage.getItem('seismicAuthToken'),
              onTokenExpired: () => onTokenExpired(),
            }}
            settings={{
              repositories: ['doccenter'],
              selectionMode: 'single',
              allowFolderSelection: false,
              viewMode: 'wide',
              language: languageMapper(),
              assetTypeFilter: {
                filterType: 'blacklist',
                values: ['LiveDoc', 'LiveDoc Component', 'Email Template'],
              },
              application: 'Lessonly',
              showPreview: true,
              customizations: {
                preview: {
                  displayPreviewOnContentIcon: true,
                  displayPreviewOnPreviewButton: true,
                  previewOnAction: 'click',
                  triggerOnPreviewCallback: false,
                  hideInbuiltPreview: false,
                },
              },
            }}
            callbacks={{
              onSelectionChanged: items => {
                if (items.length === 1) documentPicked(items[0]);
              },
            }}
          />
        </Suspense>
      </div>
    </Modal>
  );
};

export default UniversalPickerModal;
